import { Component, ErrorHandler, OnInit } from '@angular/core'
import { MergedExceptionHandler, SentryExceptionHandler, AnalyticsDataProvider } from '@mprep/shared'
import { AppContext } from '@mprep/shared/lib/helpers'

import { UIExpirationMessageService, AppStateService } from '../shared'
import { PathConfiguration } from '@mprep/shared/data/models'
import { Observable } from 'rxjs/Observable'

@Component({
  selector: 'mp-authenticated-app',
  templateUrl: './authenticated-app.html',
  styleUrls: ['./authenticated-app.scss']
})
export class AuthenticatedAppComponent implements OnInit {

  constructor(
    private _appContext: AppContext,
    private _expirationMessageService: UIExpirationMessageService,
    private _mergedExceptionHandler: MergedExceptionHandler,
    private _analyticsDataProvider: AnalyticsDataProvider,
    private _appStateService: AppStateService
  ) {}

  public ngOnInit() {
    this._analyticsDataProvider.set('userId', this._appContext.currentUser.id)
    this._analyticsDataProvider.set('testline', this._appContext.apiToken.getIssuingTestline())
    Observable.of(this._appStateService.pathConfiguration)
      .merge(this._appStateService.pathConfigurationChanged)
      .subscribe(this._setAnalyticsPathConfig.bind(this))

    this._tryInitializeSentryUserInfo(this._appContext)
    this._expirationMessageService.broadcastExpiringProducts().subscribe()
  }

  private _setAnalyticsPathConfig(config) {
    config.rootPathNode = config.rootPathNode || {}
    this._analyticsDataProvider.set('currentPath', {
      id: config.rootPathNode.id,
      name: config.rootPathNode.title,
      experience: config.experienceType
    })
  }

  private _tryInitializeSentryUserInfo(appContext: AppContext) {
    let validatedHandler = this._mergedExceptionHandler
      .getHandlerInstance<SentryExceptionHandler>(SentryExceptionHandler)
    if (typeof validatedHandler !== 'undefined') {
      validatedHandler.addInfo('id', appContext.currentUser.id)
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/authenticated-app/authenticated-app.component.ts